import { Button } from "antd";
import { useHistory } from "react-router";
import styled from "styled-components";

import { TopHighLight } from "@components";
import { PATH_REGISTER_ORDER } from "@configs";
import { useSelector } from "react-redux";
import { useFullScreen } from "src/Helpers/useFullscreen";
import { selectMerchant } from "src/Redux/Slices/merchant";
import { BackIcon } from "../icon/TopSpender/BackIcon";
export const ComponentChannelCollect = () => {
    const history = useHistory();
    const fullHeight = useFullScreen();
    const { themes } = useSelector(selectMerchant);

    return (
        <StyledContainer color={themes?.themeColor!} style={{ height: fullHeight }}>
            <div className="container">
                <div className="backIcon" onClick={() => history.goBack()}>
                    <BackIcon color={"#FFF"} />
                </div>
                <div className="header">Channel Collect Point</div>
                <div className="highlight-section">
                    <div className="highlight-section-title">
                        <TopHighLight color={"#000"} />
                        <div className="logo-section-title">
                            <img src="../images/ic-thestore-highlight.svg" alt="" />
                        </div>
                        <div className="title-section-title">
                            <img src="../images/ic-title-highlight.svg" alt="" />
                        </div>
                        <div className="content-section-title">
                            SYNC ORDER NOW GET{" "}
                            <span>
                                <img src="../images/ic-coin-highlight.svg" alt="" />
                            </span>{" "}
                            15 POINTS
                        </div>
                    </div>
                    <div className="highlight-section-content">
                        <div className="content-item">
                            <div className="item-channel">
                                <div className="img-item-channel">
                                    <img src="../images/img-collect-01.png" />
                                </div>
                                <div className="text-box">
                                    <div>
                                        <div className="title">Sync Order e-Commerce Platform</div>
                                        <div className="description">
                                            <div className="text-dec">
                                                Description how to collect
                                            </div>
                                        </div>
                                    </div>
                                    <Button
                                        className="button"
                                        onClick={() => history.push(PATH_REGISTER_ORDER)}
                                    >
                                        SELECT
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="list-content-item">
                    <div className="title-content-item">other channel</div>
                    <div className="content-item">
                        <div className="item-channel">
                            <div className="img-item-channel">
                                <img src="../images/img-collect-01.png" />
                            </div>
                            <div className="text-box">
                                <div>
                                    <div className="title">Sync Order e-Commerce Platform</div>
                                    <div className="description">
                                        <div className="text-dec">Description how to collect</div>
                                    </div>
                                </div>
                                <Button
                                    className="button"
                                    onClick={() => history.push(PATH_REGISTER_ORDER)}
                                >
                                    SELECT
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="content-item">
                        <div className="item-channel">
                            <div className="img-item-channel">
                                <img src="../images/img-collect-01.png" />
                            </div>
                            <div className="text-box">
                                <div>
                                    <div className="title">Sync Order e-Commerce Platform</div>
                                    <div className="description">
                                        <div className="text-dec">Description how to collect</div>
                                    </div>
                                </div>
                                <Button
                                    className="button"
                                    onClick={() => history.push(PATH_REGISTER_ORDER)}
                                >
                                    SELECT
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="content-item">
                        <div className="item-channel">
                            <div className="img-item-channel">
                                <img src="../images/img-collect-01.png" />
                            </div>
                            <div className="text-box">
                                <div>
                                    <div className="title">Sync Order e-Commerce Platform</div>
                                    <div className="description">
                                        <div className="text-dec">Description how to collect</div>
                                    </div>
                                </div>
                                <Button
                                    className="button"
                                    onClick={() => history.push(PATH_REGISTER_ORDER)}
                                >
                                    SELECT
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledContainer>
    );
};
const StyledContainer = styled.div<{ color: string }>`
    // background-color: ${(p) => p.color};
    background-color: #336c51;
    padding: 32px 16px;
    .container {
        .list-content-item {
            .title-content-item {
                font-size: 14px;
                line-height: 17px;
                color: #fff;
                font-weight: 600;
                margin-bottom: 12px;
                text-transform: uppercase;
            }
        }
        .backIcon {
            display: flex;
            cursor: pointer;
            z-index: 1;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            position: absolute;
            left: 16px;
            top: 32px;
        }
        .header {
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            line-height: 19px;
            text-align: center;
        }
        .highlight-section {
            margin-top: 10px;
            margin-bottom: 30px;
            .highlight-section-title {
                position: relative;
                .logo-section-title {
                    position: absolute;
                    top: 12px;
                    left: 4px;
                }
                .title-section-title {
                    position: absolute;
                    top: 6px;
                    left: 60px;
                }
                .content-section-title {
                    position: absolute;
                    width: 180px;
                    left: 60px;
                    top: 50px;
                    color: #fff;
                    font-size: 18px;
                    line-height: 15px;
                    span {
                        position: relative;
                        top: 5px;
                    }
                }
            }
            .highlight-section-content {
                background-color: #000;
                padding: 12px 10px;
                border-top-right-radius: 12px;
                border-bottom-right-radius: 12px;
                border-bottom-left-radius: 12px;
                margin-top: -1px;
                .content-item {
                    padding-bottom: 0;
                }
            }
        }
        .content-item-highlight {
            padding-top: 100px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-width: 10px;
            border-color: #ff0000;
        }
        .content-item {
            padding-bottom: 10px;
            width: 100%;
            .text-box {
                width: 100%;
                min-height: 75px;
                display: flex;
                align-items: center;
            }
            img {
                width: 64px;
                height: 64px;
                border-radius: 12px;
            }
            .item-channel-highlight {
                display: flex;
                width: 100%;
                padding: 12px 10px;
                align-items: center;
                gap: 12px;
                border-radius: 0px 12px 12px 12px;
                border: 10px solid #c4a363;
                background: #fff;
                position: relative;
                .img-top {
                    position: absolute;
                    top: -91px;
                    z-index: 1;
                    left: -10px;
                    width: 268px;
                    height: 91px;
                    .img-highlight {
                        position: relative;
                        top: -105px;
                        left: 50px;
                        height: 19.102px;
                        width: 90.986px;
                        transform: rotate(-7deg);
                    }
                    .img-logo {
                        position: relative;
                        top: -80px;
                        left: -88px;
                        height: 46px;
                        width: 46px;
                        object-fit: cover;
                    }
                    .text-to-claim {
                        position: relative;
                        color: #fff;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 700;
                        top: -105px;
                        left: 50px;
                    }
                }
                .title {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                }
                .text-dec {
                    color: #9b9b9b;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                }
                .description {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .button {
                    display: flex;
                    padding: 6px 12px;
                    justify-content: center;
                    align-items: center;
                    gap: 0px;
                    border-radius: 10px;
                    background: ${({ color }) => color};
                    color: #fff;
                    text-align: center;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: normal;
                }
            }
            .item-channel {
                width: 100%;
                padding: 12px 10px;
                padding-left: 95px;
                padding-right: 70px;
                border-radius: 12px;
                border: 1px solid #c4a363;
                background: #fff;
                position: relative;
                .img-item-channel {
                    position: absolute;
                    left: 10px;
                    top: 12px;
                    width: 70px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .title {
                    color: #000;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 17px;
                    margin-bottom: 8px;
                    word-wrap: break-word;
                }
                .text-dec {
                    color: #9b9b9b;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    word-wrap: break-word;
                }
                .button {
                    position: absolute;
                    bottom: 12px;
                    right: 10px;
                    display: flex;
                    padding: 6px 12px;
                    justify-content: center;
                    align-items: center;
                    gap: 0px;
                    border-radius: 10px;
                    background: ${({ color }) => color};
                    color: #fff;
                    text-align: center;
                    font-size: 12px;
                    line-height: 15px;
                    font-weight: 500;
                }
            }
        }
    }
`;
